// extracted by mini-css-extract-plugin
export default {"Container":"Table_Container__GU+E5","Table":"Table_Table__zBw6F","Hover":"Table_Hover__sd0XW","NoHover":"Table_NoHover__6uPfb"};